import * as IF from "infrontjs";

import { View } from "./View";
import { Api } from "./Api";
import { Storage } from "./Storage";

import { IndexState } from "../states/index/IndexState";
import { LoginState } from "../states/auth/LoginState";
import { RegisterState } from "../states/auth/RegisterState";
import { ForgotPasswordState } from "../states/auth/ForgotPasswordState";
import { LogoutState } from "../states/auth/LogoutState";
import { TokenState } from "../states/auth/TokenState";
import { LogsState } from "../states/admin/LogsState";
import { SettingsState } from "../states/admin/SettingsState";
import { ApiTokenState } from "../states/admin/ApiTokenState";
import { PremiumState } from "../states/admin/PremiumState";
import { AccountSettingsState } from "../states/account/AccountSettingsState";
import { TemplateCreateState } from "../states/template/TemplateCreateState";
import { TemplateListState } from "../states/template/TemplateListState";
import { TemplateEditState } from "../states/template/TemplateEditState";
import { TemplateDetailState } from "../states/template/TemplateDetailState";
import { PackListState } from "../states/pack/PackListState";
import { PackCreateState } from "../states/pack/PackCreateState";
import { PackEditState } from "../states/pack/PackEditState";
import { PackDetailState } from "../states/pack/PackDetailState";
import { HelpState } from "../states/help/HelpState";

import { User } from "../models/User";
import { Organisation } from "../models/Organisation";


import config from "../config";
import globalConfig from "../globalConfig";

export class App extends IF.App
{
    constructor()
    {
        super();

        this.user = new User(
            {
                id: 1,
                firstname: 'Benny',
                lastname: 'Aheadware',
                email: 'info@bennyschuetz.com',
                role: 'admin'
            }
        );
        this.session = null;

        this.config = new IF.PathObject( ( IF.Helper.deepMerge( globalConfig, config ) ) );
        console.log( this.config );

        this.storage = new Storage();
        this.api = new Api( this );

        this.view = new View( this );
    }

    async init()
    {
        this.stateManager.add(
            IndexState,
            LoginState,
            LogoutState,
            RegisterState,
            ForgotPasswordState,
            TokenState,
            LogsState,
            SettingsState,
            ApiTokenState,
            PremiumState,
            AccountSettingsState,
            TemplateCreateState,
            TemplateListState,
            TemplateEditState,
            TemplateDetailState,
            PackListState,
            PackCreateState,
            PackEditState,
            PackDetailState,
            HelpState
        );

        await this.resolveSession();

        this.view.init();
    }

    async run( route = null )
    {
        await this.init();
        await super.run( route );
    }

    async destroySession()
    {
        this.storage.deleteSessionToken();
        this.api.deleteSessionToken();
        this.user = null;
        this.dispatchEvent( new CustomEvent( 'auth-user-logout' ) );
        const { requestId, result } = await this.api.delete( '/auth/session' );
        this.view.switchToAuth();
        return result;
    }

    async resolveSession()
    {
        this.user = null;
        this.organisation = null;
        const localSessionToken = this.storage.loadSessionToken();
        if ( localSessionToken )
        {
            let res = null;
            try
            {
                const { result } = await this.api.get( '/auth/session/' + localSessionToken );
                res = result;
            }
            catch ( e )
            {
                console.error( e );
                this.view.toast( 'Your session has expired. Please log in again.', 'error' );
            }

            if ( res && 200 === res.status )
            {
                // Retrieve user data
                const sessionData = res.data;
                if ( sessionData && sessionData.hasOwnProperty( 'user' ) )
                {
                    this.api.setSessionToken( localSessionToken );

                    if ( res.data.isGhost )
                    {
                        sessionData.user.isGhostSession = true;
                    }

                    if ( sessionData.organisation )
                    {
                        this.organisation = new Organisation( sessionData.organisation );
                    }

                    this.user = new User( sessionData.user );
                    this.dispatchEvent( new CustomEvent( 'auth-user-login' ) );
                    this.view.switchToInApp();
                }
            }
            else
            {
                this.storage.deleteSessionToken();
                this.view.switchToAuth();
            }
        }
    }
};
